import { serializeCredential, type GuestCredentialInput } from './credential'
import { voucherCardFields, type EntryMethod, type VoucherCard } from './voucherCard'

export interface GrantAccessInput {
  zoneId: string
  mac: string
  ip: string | null
  nasIdentifier: string
  userAgent: string
  credential: GuestCredentialInput
  entryMethod?: EntryMethod
  campaignId?: string | null
  locale: string
}

export interface AccountVoucherInput {
  zoneId: string
  mac: string
  ip: string | null
  nasIdentifier: string
  login: string
  password: string
  card: VoucherCard
  entryMethod: EntryMethod
}

export function accessRequestBody(input: GrantAccessInput): Record<string, unknown> {
  return {
    zoneId: input.zoneId,
    mac: input.mac,
    ip: input.ip,
    userAgent: input.userAgent,
    credential: serializeCredential(input.credential),
    campaignId: input.campaignId ?? null,
    locale: input.locale,
    nasIdentifier: input.nasIdentifier,
    ...(input.entryMethod ? { entryMethod: input.entryMethod } : {}),
  }
}

export function accountVoucherRequestBody(input: AccountVoucherInput): Record<string, unknown> {
  return {
    zoneId: input.zoneId,
    mac: input.mac,
    ip: input.ip,
    nasIdentifier: input.nasIdentifier,
    login: input.login.trim(),
    password: input.password,
    ...voucherCardFields(input.card),
    entryMethod: input.entryMethod,
  }
}
